(() => {
  if (customElements.get('article-lookbook-share')) return;

  customElements.define('article-lookbook-share', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      if (!this.button || !this.status || !navigator.clipboard?.writeText) return;
      this.button.hidden = false;
      this.controller?.abort();
      this.controller = new AbortController();
      this.button.addEventListener('click', async () => {
        this.button.disabled = true;
        try {
          await navigator.clipboard.writeText(this.button.dataset.copyUrl);
          this.status.textContent = this.status.dataset.copySuccess;
        } catch {
          this.status.textContent = this.status.dataset.copyError;
        } finally {
          this.button.disabled = false;
        }
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
})();